import { fetchManifest } from './api/fetchManifest'
import { loadLocale } from './api/loadLocale'
import { getVueI18n } from './i18n'
import { pickUserLocale } from './pickUserLocale'
import type { Config } from './types/Config'
import type { ProjectManifest } from './types/ProjectManifest'
import type { UserConfig } from './types/UserConfig'

const manifestPromise = fetchManifest()

export async function loadLocales(userConfig: UserConfig = {}) {
  const i18n = getVueI18n()

  const manifest = await manifestPromise

  const config = getConfigWithDefaults(userConfig, manifest)

  const { locale, fallbackLocale } = config

  await loadLocale(manifest, locale)
  i18n.locale = locale

  if (fallbackLocale !== locale) {
    await loadLocale(manifest, fallbackLocale)
    i18n.fallbackLocale = fallbackLocale
  }
}

function getConfigWithDefaults(
  config: UserConfig,
  manifest: ProjectManifest
): Config {
  const supportedLocales =
    config.supportedLocales ?? Object.keys(manifest.locales)

  const fallbackLocale = config.fallbackLocale ?? manifest.baseLocale

  const locale =
    config.locale ?? pickUserLocale(supportedLocales, fallbackLocale)

  return { supportedLocales, fallbackLocale, locale }
}
